import { render } from "./RoteirosView.vue?vue&type=template&id=30dcb654&scoped=true"
import script from "./RoteirosView.vue?vue&type=script&lang=js"
export * from "./RoteirosView.vue?vue&type=script&lang=js"

import "./RoteirosView.vue?vue&type=style&index=0&id=30dcb654&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30dcb654"]])

export default __exports__